import Api from "@/services/Api";

export default {
  get(pageNumber, content_type, category) {
    // Get by category
    if (category && category !== "") {
      return Api().get(
        "/rbm/v1/resources/category/?page=" +
          pageNumber +
          "&type=" +
          content_type +
          "&filter=" +
          category
      );
    }
    // Get by contnt type
    if (content_type && content_type !== "") {
      if (content_type === "blog") {
        content_type = "post";
      }
      return Api().get(
        "/rbm/v1/resources/type/?page=" + pageNumber + "&type=" + content_type
      );
    }
    // Get all resources
    if (content_type == "" && category == "") {
      return Api().get("/rbm/v1/resources/?page=" + pageNumber);
    }
  }
};
